export type Vector = [number, number]

export { V }

class V {
  static add(a: Vector, b: Vector): Vector {
    return [a[0] + b[0], a[1] + b[1]]
  }

  static subtract(a: Vector, b: Vector): Vector {
    return [a[0] - b[0], a[1] - b[1]]
  }

  static norm(v: Vector): number {
    return Math.hypot(v[0], v[1])
  }

  static normalize(v: Vector): Vector {
    return V.toLength(v, 1)
  }

  static toLength(v: Vector, length: number): Vector {
    return V.multiply(v, length / V.norm(v))
  }

  static squaredNorm(v: Vector): number {
    return V.dot(v, v)
  }

  static distance(a: Vector, b: Vector): number {
    return V.norm(V.subtract(a, b))
  }

  static dot(a: Vector, b: Vector): number {
    return a[0] * b[0] + a[1] * b[1]
  }

  static cross(a: Vector, b: Vector): number {
    return a[0] * b[1] - a[1] * b[0]
  }

  static multiply(v: Vector, f: number): Vector {
    return [v[0] * f, v[1] * f]
  }

  static leftOrthogonal(v: Vector): Vector {
    return [v[1] !== 0 ? -v[1] : 0, v[0]]
  }

  static rightOrthogonal(v: Vector): Vector {
    return [v[1], v[0] !== 0 ? -v[0] : 0]
  }

  static equals(a: Vector, b: Vector): boolean {
    return a[0] === b[0] && a[1] === b[1]
  }
}
